// extracted by mini-css-extract-plugin
export default {"cartBg":"Shipping_cartBg__dHBDF","cartAndSummaryContainer":"Shipping_cartAndSummaryContainer__A-qX2"};